import { Modal } from '@eventbrite/eds-modal';
import React, { useState } from 'react';
import { useAppContext } from '../../../AppContext';
import { IAuthProps } from '../../../shared';
import { TestingPanel } from '../../../shared/TestingPanel';
import { CreateAccountForm } from './CreateAccountForm';
import './CreateAccountModal.scss';

export const CreateAccountModal = ({
    authProps,
}: {
    authProps?: IAuthProps;
}) => {
    const {
        eventCreationFailed,
        isModalShowing,
        isPerformingAsyncAction,
        updateContext,
    } = useAppContext();

    const [isSuccess, setIsSuccess] = useState(false);

    const handleModalClose = () => {
        updateContext({ isModalShowing: false });
    };

    const hideCloseButton = eventCreationFailed || isPerformingAsyncAction;

    return (
        <Modal
            isShown={isModalShowing}
            noPadding
            noMinHeight
            disableCloseOnClickOutside={isSuccess ? false : true}
            onClose={hideCloseButton ? undefined : handleModalClose}
        >
            <CreateAccountForm
                handleModalClose={handleModalClose}
                setIsSuccess={setIsSuccess}
                authProps={authProps}
            />
            <TestingPanel />
        </Modal>
    );
};
